export const calculateExpireDate = (days = 365): Date => {
  const expireDate = new Date();
  expireDate.setDate(expireDate.getDate() + days);
  return expireDate;
};
